import React from 'react';
import PropTypes from 'prop-types';
import { css } from 'linaria';
import classnames from 'classnames';
import { headingSansSerif } from '@pocket/web-ui';
const modalHeaderStyles = "m1oixje6";
export const ModalHeader = ({
  title,
  hasBorder,
  isSticky,
  className
}) => {
  return <h6 data-cy="modal-header" className={classnames(modalHeaderStyles, {
    bordered: hasBorder,
    sticky: isSticky
  }, className)}>
      {title}
    </h6>;
};
ModalHeader.propTypes = {
  title: PropTypes.string.isRequired,
  hasBorder: PropTypes.bool,
  isSticky: PropTypes.bool
};
ModalHeader.defaultProps = {
  hasBorder: true,
  isSticky: true
};
export default ModalHeader;

require("./modal-header.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./modal-header.js");